import myaxios from "@/utils/myaxios";

export default{
    // 主要用于向后台发送数据
    postList(urls, data){
        const promise1 = myaxios({
            method: 'post',
            headers: {'Authorization': 'JWT ' + localStorage.getItem('token') },
            url: urls,
            data: data,
        })
        return promise1;
    },
    postListP(urls, data, params){
        const promise1 = myaxios({
            method: 'post',
            headers: {'Authorization': 'JWT ' + localStorage.getItem('token') },
            url: urls,
            data: data,
            params: params,
        })
        return promise1;
    },
    // 主要用于向后台上传文件
    uploadFiles(urls, file){
        const promise1 = myaxios({
            method: 'post',
            headers: {'Content-Type': 'multipart/form-data'},
            url: urls,
            data: file,
        })
        return promise1;
    },
    // 主要用于向后台上传文件，以及token认证
    uploadFilesAuth(urls, file){
        const promise1 = myaxios({
            method: 'post',
            headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'JWT ' + localStorage.getItem('token') },
            url: urls,
            data: file,
        })
        return promise1;
    },
    // 主要用于向后台上传文件，且自带参数
    // 这里的params后台可以通过request.GET.get获取，但是不能通过request.POST.get获取
    // 获取也可以把params统一绑定到file所在的字典里
    uploadFilesP(urls, file, params){
        const promise1 = myaxios({
            method: 'post',
            headers: {'Content-Type': 'multipart/form-data'},
            url: urls,
            data: file,
            params: params,
        })
        return promise1;
    },
    // 主要用于从后台下载文件
    downloadFiles(urls, file){
        const promise1 = myaxios({
            method: 'post',
            // 'blob'表示返回是个文件
            responseType: 'blob',
            url: urls,
            data: file,
        })
        return promise1;
    },
    // 主要用于从后台下载文件，且自带参数
    downloadFilesP(urls, file, params){
        const promise1 = myaxios({
            method: 'post',
            // 'blob'表示返回是个文件
            responseType: 'blob',
            url: urls,
            data: file,
            params: params,
        })
        return promise1;
    }
}